import VueViewer from "v-viewer";
import "viewerjs/dist/viewer.css";

import VideoPlayer from 'vue-video-player/src'
import 'video.js/dist/video-js.css' 
import 'vue-video-player/src/custom-theme.css'
import VueSignaturePad from 'vue-signature-pad';
export function setupThirdLib(app) {
  app.use(VueViewer);
  app.use(VideoPlayer);
  app.use(VueSignaturePad);
  
}
